import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";
import { sharedRequirementsQueriesConfig } from "../utils";
import { QueriesOptions } from "@tanstack/react-query/build/lib/useQueries";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";

const getDataSourceQuery = <T>(
  key: string,
  requirement: IRequirementResponse,
  fetchFunction: (dataSourceId: string) => Promise<T>
) => {
  const replacedDataSourceId = requirement.replacedRequirement?.dataSourceId;

  const queries = [
    {
      queryKey: [key, requirement.dataSourceId],
      queryFn: () => fetchFunction(requirement.dataSourceId),
      ...sharedRequirementsQueriesConfig
    },
    replacedDataSourceId
      ? {
          queryKey: [key, replacedDataSourceId],
          queryFn: () => fetchFunction(replacedDataSourceId),
          ...sharedRequirementsQueriesConfig
        }
      : undefined
  ].filter(Boolean) as NonNullable<QueriesOptions<any>>[];

  return queries;
};

export const getDataSourceQueries = <T>(
  key: string,
  requirements: IRequirementResponse[],
  fetchFunction: (dataSourceId: string) => Promise<T>,
  requirementType: RequirementType
): NonNullable<QueriesOptions<any>>[] => {
  const queries = requirements
    .filter(
      requirement =>
        requirement.requirementType === requirementType &&
        requirement.dataSourceId
    )
    .map(requirement => getDataSourceQuery(key, requirement, fetchFunction))
    .flat();

  return queries;
};
